import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Indoor_Cameras/IN-8015_HD/Videos/video-8015-lense-adjust";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};